const { expect } = require('chai');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

describe('Download content assets', () => {
  describe('download assets under a given path', () => {
    const mock = loadRecordedMock(
      'migrate_assets_download_includePaths_preview.json'
    );
    const count = Object.keys(
      mock.response?.entriesToMigrate?.entryIds?.image || {}
    ).length;

    it(`download ${count} assets`, (done) => {
      migratortronApi.post(
        'migrate/assets/download?includePaths',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          expect(body.errors).to.not.exist;
          if (body.error) done(body.error);

          expect(
            Object.keys(body.entriesToMigrate?.entryIds?.image || {}).length
          ).to.equal(count);
          done();
        }
      );
    });
  });

  describe('download a single asset matching a search term', () => {
    const mock = loadRecordedMock(
      'migrate_assets_download_searchTerm_preview.json'
    );

    it(`download one asset`, (done) => {
      migratortronApi.post(
        'migrate/assets/download?searchTerm',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          expect(body.errors).to.not.exist;
          if (body.error) done(body.error);

          expect(body.entriesToMigrate?.entryIds?.image).to.be.an('object');
          expect(body.entriesToMigrate?.migratortronTarget?.totalCount).to.equal(1);
          done();
        }
      );
    });
  });
});
